// @flow
import React, {useEffect} from 'react';
import {useForm, useFieldArray, Controller} from 'react-hook-form';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import ArticleSelector from "../articles/ArticleSelector";
import {sectionPath} from "../../lib/config";
import Checkbox from "material-ui/Checkbox";

export const BlockForm = (props) => {
	const { onSubmit, serverError, children, initialValues = {} } = props;

	const {
		control,
		register,
		formState: { errors },
		handleSubmit,
	} = useForm({
		defaultValues: initialValues
	});

	const { fields, append, remove } = useFieldArray({
		control,
		name: "linked",
	});


	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Controller
				name='title'
				control={control}
				rules={{ required: true }}
				render={({ fieldState: { error }, field: { onChange,  value } }) => (
					<TextField
						value={value}
						errorText={error ?  'Название обязетельно для заполнения' : ''}
						onChange={onChange}
						floatingLabelText="Название рекламного блока"
						fullWidth
						floatingLabelFixed={true}
					/>
				)}
			/>
			<Controller
				name='slug'
				control={control}
				rules={{ required: true }}
				render={({ fieldState: { error }, field: { onChange,  value } }) => (
					<TextField
						value={value}
						errorText={error ?  'Системное название блока обязетельно для заполнения' : ''}
						onChange={onChange}
						floatingLabelText="Системное название блока"
						fullWidth
						floatingLabelFixed={true}
					/>
				)}
			/>
			<Controller
				name="active"
				control={control}
				defaultValue={initialValues.true || true}
				render={({ field: { onChange, value } }) => <Checkbox label="Active" onCheck={onChange} checked={value} />}
			/>
			<ArticleSelector
				limit={1}
				section={sectionPath.news}
				floatingLabelFixed
				itemProvider={(t, index)=> {
					return (
						<div style={{display: "flex", gap: 20, alignItems: "center"}}>
							<div style={{ width: 450 }}>{t.title}</div>
							<input type="hidden"  {...register(`linked.${index}.id`)} defaultValue={t.id} />
							<Controller
								name={`linked.${index}.customTitle`}
								control={control}
								render={({ field: { onChange, value } }) => (
									<TextField
										value={value}
										onChange={onChange}
										floatingLabelText="Заголовок"
										fullWidth
										floatingLabelFixed={true}
									/>
								)}
							/>

						</div>
					)
				}}
				onAdd={append}
				onRemove={remove}
				placeholder="Начните ввод"
				hint="Добавленные статьи"
				viewer={props.viewer}
				value={fields}
				disabled={false}
			/>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<RaisedButton
					label="Сохранить"
					type="submit"
					primary={true}
				/>
				{children}
			</div>

		</form>
	);
};


// WEBPACK FOOTER //
// src/components/blocks/BlockForm.js